const accessMixin = {
  methods: {
    hasAccess(entidade: string, acao: string): boolean {
      const { permissoes } = this.$store.getters;
      if (permissoes[entidade] !== undefined && permissoes[entidade][acao] !== undefined) {
        return permissoes[entidade][acao];
      }
      return false;
    },
  },
};

export default accessMixin;
